





















































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { SumupGroup, CurriculumResult, BunpuResult, ColKindEnum } from "../../modules/practice_examinee/ResultList"

export interface Data {
  practice_examinee_id: string
  sumupGroup: SumupGroup
  curriculumResults: CurriculumResult[]
  curriculumIds: number[]
  isExistsResultImage: boolean
  bunpuTotalResults: BunpuResult[]
  total_curriculum_ids: number[]
  totalMaxParcents: number[]
  bunpuIdxs: number[]
  ColKindEnum: Readonly<{ScoreRange: number; Count: number; ScoreRate: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      practice_examinee_id: null,
      sumupGroup: null,
      curriculumResults: [],
      curriculumIds: [],
      isExistsResultImage: false,
      bunpuTotalResults: [],
      total_curriculum_ids: [],
      totalMaxParcents: [],
      bunpuIdxs: [],
      ColKindEnum: ColKindEnum,
      errors: [],
    });

    /************************************************************
     * 得点分布グラフのCSSクラス
     ************************************************************/

    const graphStyleClass = (rowIdx: number, colIdx: number) => {
      let rtn: any = {};
      if(colIdx == 2 && rowIdx == state.bunpuIdxs[0]){
        rtn["obi"] = true;
      }else if(colIdx == 5 && rowIdx == state.bunpuIdxs[1]){
        rtn["obi"] = true;
      }else if(colIdx == 8 && rowIdx == state.bunpuIdxs[2]){
        rtn["obi"] = true;
      }else{
        rtn["yoda"] = true;
      }
      return rtn;
    }

    const graphWidth = (per: number) => {
      let width = 100;
      if(per < 30){
        width = per * 100 / 30;
      }
      return width;
    }

    /************************************************************
     * 教科別詳細アイコン押下
     ************************************************************/

    const toResultDetail = (curriculum_id: number) => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.PracticeExaminee){
        context.root.$router.push(`/candidate/result_detail/${state.practice_examinee_id}/${curriculum_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/practice_examinee_result_detail/${state.practice_examinee_id}/${curriculum_id}`).catch(err => {});
      }
      
    }

    /************************************************************
     * 答案画像ダウンロード
     ************************************************************/

    const downloadTouanZip = async () => {
      if(!window.confirm("答案画像をダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/practice_examinee/result_list/download_touan_zip/${state.practice_examinee_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sumupGroup.name} 答案.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 初期表示データ取得
     ************************************************************/

    const initialize = async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      context.root.$store.commit("setIsHeaderDisp", true);
      state.practice_examinee_id = context.root.$route.params.practice_examinee_id;

      await http.get(`/api/practice_examinee/result_list?practice_examinee_id=${state.practice_examinee_id}`).then(response => {
        state.sumupGroup = response.data.sumup_group;
        state.curriculumResults = response.data.curriculum_results.map((x: any) => new CurriculumResult(x));
        state.curriculumIds = response.data.curriculum_ids;
        state.isExistsResultImage = response.data.is_exists_result_image;
        state.bunpuTotalResults = response.data.bunpu_total_results.map((x: any) => new BunpuResult(x));
        state.total_curriculum_ids = response.data.total_curriculum_ids;

        const colIdxs = [2, 5, 8]
        for(let i = 0; i < state.total_curriculum_ids.length; i++){
          state.totalMaxParcents[colIdxs[i]] = state.bunpuTotalResults.map(x => x.sumupBunpus[i].percent).reduce((a, b) => Math.max(a, b));
        }

        for(let i = 0; i < state.total_curriculum_ids.length; i++){
          const curriculumResult = state.curriculumResults.filter(x => x.curriculum_id == state.total_curriculum_ids[i]);
          if(curriculumResult.length == 0){
            state.bunpuIdxs.push(10);
            continue;
          }
          const examineeScore = curriculumResult[0].score;
          for(let j = 0; j < state.bunpuTotalResults.length; j++){
            const bunpuResult = state.bunpuTotalResults[j].sumupBunpus[i];
            if(bunpuResult.score_from <= examineeScore && bunpuResult.score_to >= examineeScore){
              state.bunpuIdxs.push(j);
            }
          }
        }
      }).catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * Mounted
     ************************************************************/

    onMounted(async () => {
      initialize();
    });

    return {
      ...toRefs(state),
      toResultDetail,
      downloadTouanZip,
      graphStyleClass,
      graphWidth,
    };
  }
})
